import { useEffect } from 'react';

export const useResizeObserver = (
    node: HTMLElement | null,
    onResize: (entry: ResizeObserverEntry) => void,
) => {
    useEffect(() => {
        let resizeObserver: ResizeObserver | undefined;
        if (node) {
            resizeObserver = new ResizeObserver(entries => {
                onResize && onResize(entries[0]);
            });

            resizeObserver.observe(node);
        }

        return () => resizeObserver?.disconnect();
    }, [node, onResize]);
};
